import { getConfig } from '../Config/ApplicationConfig';
import { MedicationSettings, StateTerritoryTermSetting } from '../Config/MedicationConfig';
import { getExecutor } from '../Shared/HttpRequestExecutor';

export function getCurrentMedicationSettings(): Promise<MedicationSettings> {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).get(`api/v1/medication-settings`);
}

export function getCurrentStateTerritoryTermSettings(): Promise<StateTerritoryTermSetting[]> {
    return getExecutor(getConfig().apiEndpoints.medicationsManagement).get(
        `api/v1/medication-settings/state-territory-term-settings`
    );
}
